import { Inject, Injectable } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { PageMetaData } from '../_models/pageMetaData';
import { HOST_URL } from '../tokens/host-url';

const defaultMetadata: PageMetaData = {
  title: 'Boldungu',
  imageRelativeUrl: 'og-default.png',
  description: 'Math practice for children',
  author: 'Benjamin Kanagwa',
  keywords: [
  "Math Practice",
  "Math fun",
  "Math game",
  "Math Preparation",
  "Improve math grades",
  "Learn by doing",
  "practice makes perfect",
  "Boldungu Math",
  "Boldungu Learning",
  "Math",
  'Mathematics',
  'Primary Mathematics',
  'Practice Makes Perfect',
  "Number Sense",
  "Improve Maths",
  "Improve Mathematics",
  "Love Mathematics",
  "Excel in Mathematics",
  "Learning Math",
  "Math Worksheets"],
  type: 'website',
}

@Injectable({
  providedIn: 'root'
})
export class SearchEngineDataService {
  constructor(private metaTagService: Meta,
              private titleService: Title,
              @Inject(HOST_URL) private hostUrl: string,
              private router: Router) {}

  public updateMetadata(metadata: Partial<PageMetaData>, index: boolean = true): void {
    const pageMetadata: PageMetaData = {...defaultMetadata, ...metadata};
    const metatags: MetaDefinition[] = this.generateMetaDefinitions(pageMetadata);

    this.metaTagService.addTags([
      ...metatags,
      { property: 'og:url', content: `${this.hostUrl}${this.router.url}`},
      { name: 'robots', content: index ? 'index, follow' : 'noindex' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
     ], false);


    this.titleService.setTitle(pageMetadata.title);
  }

  private generateMetaDefinitions(metadata: PageMetaData): MetaDefinition[] {
    return [
      { name: 'title', content: metadata.title },
      { property: 'og:title', content: metadata.title },

      { name: 'description', content: metadata.description },
      { property: 'og:description', content: metadata.description },

      { name: 'author', content: metadata.author },
      { property: 'og:author', content: metadata.author },

      { name: 'keywords', content: metadata.keywords.join(', ') },

      { property: 'og:type', content: metadata.type },

      { property: 'og:image', content: `${this.hostUrl}/${metadata.imageRelativeUrl}`}
    ];
  }
}
